import ComicCard from '@/components/base/ComicCard';
import type { Comic } from '@/mocks/comics';

interface FeaturedSectionProps {
  comics: Comic[];
}

export default function FeaturedSection({ comics }: FeaturedSectionProps) {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-1 h-6 rounded-full bg-primary-500"></div>
        <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-950">
          热门推荐
        </h2>
        <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full whitespace-nowrap">HOT</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-5">
        {comics.slice(0, 10).map((comic) => (
          <ComicCard key={comic.id} comic={comic} variant="default" />
        ))}
      </div>
    </section>
  );
}